export default __webpack_public_path__ + "static/media/csharp.fc430729.png";